import Navbar from "./components/UI/Navbar";
import Sidebar from "./components/UI/Sidebar";
import Footer from "./components/UI/Footer";
import Root from "./routes/root";
import { Toaster } from "react-hot-toast";
// Se quitó el tema comprado (style/App.css): eran 804 KB de CSS minificado con
// su propio Bootstrap dentro y selectores imposibles de sobrescribir. Ahora:
// Bootstrap del paquete, los iconos, el armazón propio y la capa de color.
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@mdi/font/css/materialdesignicons.min.css";
import "./style/layout.css";
import "./style/crud.css";
import "./style/tema.css";
import { useLocation } from "react-router-dom";

function App() {
  const { pathname } = useLocation();


  if (
    pathname === "/login" ||
    pathname === "/register" ||
    pathname === "/forgot-password" ||
    pathname === "/reset-password" ||
    pathname.includes("view-formulario")
  ) {
    return <Root />;
  }

  return (
    <div
      className="container-scroller"
      style={{
        height: "100vh",
      }}
    >
      <Sidebar />
      <Toaster position="top-right" />
      <div
        className="container-fluid page-body-wrapper"
        style={{ overflowY: "auto" }}
      >
        <Navbar />

        <div className="main-panel">
          <div className="content-wrapper">
            <Root />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
